import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/harold.webp'


const _withScopeId = n => (_pushScopeId("data-v-07a21798"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer-base" }
const _hoisted_2 = { id: "footer-main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "harold harold-left",
  src: _imports_0,
  alt: "Image of a frog named Harold holding a old curled letter with a mushroom on his head.",
  title: "Image drawn by Valentina, https://ntinaart8.wixsite.com/ntinaartportfolio"
}, null, -1))
const _hoisted_4 = { id: "text-elements" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "merch" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://bad-toad-games-llc.myspreadshop.com/" }, "Spreadshirt"),
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.redbubble.com/people/Bad-Toad-Games/shop?asc=u" }, "Redbubble")
], -1))
const _hoisted_6 = { id: "copyright" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "harold harold-right",
  src: _imports_0,
  alt: "Image of a frog named Harold holding a old curled letter with a mushroom on his head.",
  title: "Image drawn by Valentina, https://ntinaart8.wixsite.com/ntinaartportfolio"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "programmer" }, [
  /*#__PURE__*/_createTextVNode(" Website built by "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "Pignuuu"),
  /*#__PURE__*/_createTextVNode(" ("),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "StianWiu"),
  /*#__PURE__*/_createTextVNode(") ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("span", {
          id: "cookies",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.disableCookies && _ctx.disableCookies(...args)))
        }, "Disable Cookies"),
        _createElementVNode("span", _hoisted_6, " © 2022-" + _toDisplayString(_ctx.year) + " Bad Toad Games LLC, All Rights Reserved ", 1)
      ]),
      _hoisted_7
    ]),
    _hoisted_8
  ]))
}